import FF from "@/components/forms/FormField.module.css";

import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { cn } from "@/utils/classNames.ts";
import { forwardRef, type ReactNode } from "react";
import { Radio, type RadioProps } from "react-aria-components";

/** Properties that are usually declared by "radio items" */
export interface IconRadioContentProps {
    id: string;
    title: ReactNode;
    icon: string;
    desc?: string;
}

export interface IconRadioProps extends IconRadioContentProps {
    //#region Visual properties
    wide?: boolean;
    isDisabled?: RadioProps["isDisabled"];
    //#endregion
}

export const IconRadio = forwardRef<HTMLLabelElement, IconRadioProps>(function IconRadio(
    { icon, id, title, desc, wide, ...radioProps },
    ref,
) {
    return (
        <Radio ref={ref} value={id} className={cn(FF.FormFieldIconRadio, wide && FF.wide)} {...radioProps}>
            <MaskIcon className={`${icon} size-2.5rem flex-none`} />
            <div className={FF.content}>
                <div className={FF.title}>{title}</div>
                {!!desc && <div>{desc}</div>}
            </div>
        </Radio>
    );
});
